import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ACTION_FETCH } from './const';
import {
  Items,
  Organizations,
  OrganizationsResponse,
  Providers,
} from './types';
import { Dictionary } from 'vuex';

const asNumber = (value: number | string): number =>
  (value && (typeof value === 'string' ? parseInt(value, 10) : value)) || 0;

const UPDATE_ITEMS = 'updateItems';
const UPDATE_COUNT = 'updateCount';
const UPDATE_PAGE = 'updatePage';
const UPDATE_LIMIT = 'updateLimit';

const storeModule = (providers: Providers) => {
  const { $api } = providers;

  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageOrganizationsStore extends VuexModule {
    // State
    items: Items = [];
    count = 0;
    page = 0;
    limit = 0;

    // Mutations
    @Mutation
    [UPDATE_ITEMS](items: Organizations) {
      this.items = items;
    }

    @Mutation
    [UPDATE_COUNT](count: number) {
      this.count = count;
    }

    @Mutation
    [UPDATE_PAGE](page: number) {
      this.page = page;
    }

    @Mutation
    [UPDATE_LIMIT](limit: number) {
      this.limit = limit;
    }

    // Actions
    @Action
    async [ACTION_FETCH](params: Dictionary<any>): Promise<void> {
      try {
        const {
          data: { data, filtered, limit, page },
        } = await $api.get<OrganizationsResponse>('organizationlist/get', {
          params,
        });
        this.context.commit(UPDATE_COUNT, asNumber(filtered));
        this.context.commit(UPDATE_PAGE, asNumber(page));
        this.context.commit(UPDATE_LIMIT, asNumber(limit));
        this.context.commit(
          UPDATE_ITEMS,
          data.map((organization) => ({
            ...organization,
            code: organization.code || '',
            logo: organization.logo || '',
          }))
        );
      } catch (e) {
        // Обрабатываем ошибку
        this.context.commit(UPDATE_ITEMS, false);
      }
    }
  }

  return PageOrganizationsStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/organizations/list/store.ts